import { IPaginationParams } from '../../../types';
import { IStudentFilterProps } from '../../types';
import { useQuery } from 'react-query';
import {
  getAllStudentByLicenseAsync,
  getAllStudentCountByLicenseAsync,
} from '../../index';
import { getUserId } from '../../../DefaultService';

const USER_ID = getUserId();

export const useGetAllStudentByLicenseAsync = (
  pagination: IPaginationParams,
  filter: IStudentFilterProps,
) =>
  useQuery([`student${pagination.pageNumber}`, pagination, USER_ID], {
    keepPreviousData: true,
    staleTime: 1000 * 60,
    queryFn: () => getAllStudentByLicenseAsync(pagination, filter),
  });

export const useGetAllStudentByLicenseCountAsync = (
  pagination: IPaginationParams,
  filter: IStudentFilterProps,
) =>
  useQuery([`studentCount${pagination.pageNumber}`, pagination, USER_ID], {
    keepPreviousData: true,
    staleTime: 1000 * 60,
    queryFn: () => getAllStudentCountByLicenseAsync(filter),
  });
